import { Injectable } from '@angular/core';
import { DatasetClientService } from '@mode/dataset/data-access';
import { ReportClientService } from '@mode/shared/data-access-webapp';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs/operators';
import * as SchedulesActions from './schedules.actions';
import { DatasetActions } from '@mode/dataset/contract';

@Injectable()
export class SchedulesEffects {
  loadSchedules$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        SchedulesActions.loadSchedules,
        DatasetActions.loadDatasetReportEditRoute,
        DatasetActions.loadNotebookCellDatasetEditRoute
      ),
      concatMap((action) =>
        this.reportClientService
          .loadSchedules(action.datasetToken)
          .pipe(map(({ schedules }) => SchedulesActions.loadSchedulessSuccess({ schedules })))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private datasetClientService: DatasetClientService,
    private reportClientService: ReportClientService
  ) {}
}
